/**
 * Calendriers / anniversaires stockés à minuit UTC (ex. dateOfBirth en base).
 */

/**
 * Valeur pour <input type="date"> : partie date ISO en UTC (= jour civil enregistré).
 * @param {string|number|Date} value
 * @returns {string} '' ou YYYY-MM-DD
 */
export function formatDateForHtmlInput(value) {
  if (value === null || value === undefined || value === '') return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  try {
    return d.toISOString().slice(0, 10);
  } catch {
    return '';
  }
}

/**
 * Affichage sans décalage de fuseau (ex. 1971-01-12 UTC → « 12.01.1971 » en fr-CH).
 * @param {string|number|Date} value
 * @param {string} locale
 * @returns {string}
 */
export function formatBirthDateDisplayUtc(value, locale = 'fr-CH') {
  if (value === null || value === undefined || value === '') return '';
  const d = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(locale, { timeZone: 'UTC' });
}

/**
 * @param {string} lang — ex. valeur `locale` depuis LanguageContext ('fr', 'it', ...)
 * @returns {string} ICU locale pour formater les dates de naissance
 */
export function birthDisplayLocaleFromApp(lang) {
  const l = String(lang || 'fr').toLowerCase().split('-')[0];
  if (l === 'it') return 'it-CH';
  if (l === 'en') return 'en-GB';
  return 'fr-CH';
}

/** Affichage long (jour/mois textual) avec zone UTC — utile hors formulaires courts */
export function formatDateUtcLocale(dateString, locale = 'fr-FR') {
  if (!dateString) return 'N/A';
  const d = new Date(dateString);
  if (Number.isNaN(d.getTime())) return 'N/A';
  return d.toLocaleDateString(locale, {
    timeZone: 'UTC',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
}
